import { z } from 'zod';
import { TFunction } from 'i18next';

import { CONTACT_FIELD_MAX_LENGTH as MAX } from './constants';

/** As the legacy contact form: only the name is required. */
export const createContactSchema = (t: TFunction) => {
  const email = z.string().max(MAX.email).email(t('validity.typeMismatch.email')).or(z.literal(''));
  const phone = z.string().max(MAX.phone);

  return z.object({
    title: z.string().max(MAX.title),
    name: z.string().min(1, t('validity.valueMissing.defaultMessage')).max(MAX.name),
    jobTitle: z.string().max(MAX.jobTitle),
    address: z.string().max(MAX.address),
    email1: email,
    email2: email,
    email3: email,
    phone1: phone,
    phone2: phone,
    phone3: phone
  });
};

export type ContactFormValues = z.infer<ReturnType<typeof createContactSchema>>;

export const DEFAULT_CONTACT_VALUES: ContactFormValues = {
  title: '',
  name: '',
  jobTitle: '',
  address: '',
  email1: '',
  email2: '',
  email3: '',
  phone1: '',
  phone2: '',
  phone3: ''
};
